import { createSelector } from 'reselect';

export interface MainState {
  ready: boolean;
  loading: boolean;
  error: string;
}

export const initialState: MainState = {
  ready: false,
  loading: false,
  error: '',
};

const getMain = ({ main }: any): MainState => main;

export const mainSelectors = {
  getLoading: createSelector(
    [getMain],
    ({ loading }) => loading,
  ),
  getReady: createSelector(
    [getMain],
    ({ ready }) => ready,
  ),
};



// WEBPACK FOOTER //
// ./src/Main/services/selectors.ts